


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

type size = 'small' | 'medium' | 'large';
type type = 'text' | 'number';
@Component({
  name: 'InputComponent'
})
export default class InputComponent extends Vue {
  public val: string = '';

  @Prop({ required: false })
  public size: size;

  @Prop({ required: false })
  public value: number;

  @Prop({ required: false })
  public type: type;

  @Prop({ required: false })
  public invalid: boolean;

  @Prop({ required: false })
  public hasWarning: boolean;

  @Prop({ required: true })
  public showSaveButtonProp: boolean;

  @Prop({ required: true })
  public styleInput: string; 

  public styleDiv: string = '';

  public created() {
    this.updateValue();
  }

  @Watch('value')
  public updateValue() {
    this.val = (this.value || '').toString();
  }

  public update() {
    this.$emit('click', this.val);
  }

  public emitNewValue() {
    this.$emit('focusin', this.val);
  }

   public emitNewValueOut() {
    this.$emit('focusout', this.val);
  }

  public emitNewKeyUp(event) {
    this.$emit('keyup', this.val);
  }
}
